export const sidebarSearchProcessRequests = /* GraphQL */ `
  query SidebarSearchProcessRequests(
    $filter: SearchableProcessRequestFilterInput
    $sort: [SearchableProcessRequestSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchProcessRequests(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    )  {
      items {
        id
        assignedToID
        companyID
        company {
          name
          displayCompanyName
        }
        initiatorID
        initiator {
          id
          slug
          firstname
          lastname
        }
        requesterID
        requester {
          id
          slug
          firstname
          lastname
        }
        requestDate
        employeeData {
          email
          firstname
          lastname
        }
        employmentData {
          startDate
        }
        lowerNationalName
        foreignNationalID
        foreignNational {
          id
          slug
          email
          firstname
          lastname
          spouse
          dependents
          avatar {
            original {
              bucket
              key
              level
              region
              identityId
            }
            square {
              bucket
              key
              level
              region
              identityId
            }
            squareThumbnails {
              image {
                bucket
                key
                level
                region
                identityId
              }
              size
            }
            version
          }
          company {
            name
            displayCompanyName
          }
          immigrationStatus {
            status
            expiration
          }
        }
        requestedProcess
        slug
        state
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const processBySlug = /* GraphQL */ `
  query CustomProcessBySlug($slug: String!) {
    processBySlug(slug: $slug) {
      items {
        id
      }
    }
  }
`;

export const getProcessRequest = /* GraphQL */ `
  query CustomGetProcessRequest($id: ID!) {
    getProcessRequest(id: $id) {
      id
      companyID
      company {
        slug
        id
        name
        displayCompanyName
        primaryContacts {
          items {
            employerID
          }
        }
        data {
          addressPrimary {
            careOf
            address
            unitNumber
            unitType
            adminArea
            state
            city
            country
            postalCode
            title
            companyAddressType
          }
          addressSecondary {
            careOf
            address
            unitNumber
            unitType
            adminArea
            state
            city
            country
            postalCode
            title
            companyAddressType
          }
        }
        accountManagerID
      }
      assignedToID
      assignedToEmployer {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
          version
        }
      }
      assignedToTeamMember {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
          version
        }
      }
      initiatorID
      employeeData {
        firstname
        lastname
        employeeId
        email
        tempID
        spouse
        dependents
      }
      employmentData {
        location {
          remoteAddress {
            address
            unitType
          }
          type
        }
        notes
        premiumProcessing
        startDate
        salary {
          currency
          amount
        }
      }
      initiator {
        id
        slug
        firstname
        lastname
      }
      requesterID
      requester {
        id
        firstname
        lastname
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
          version
        }
      }
      requestDate
      lowerNationalName
      foreignNationalID
      foreignNational {
        id
        archived
        slug
        email
        firstname
        employeeId
        lastname
        spouse
        dependents
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
        immigrationStatus {
          status
          expiration
        }
      }
      caseNotes {
        items {
          authorTeamMember {
            id
            lastname
            firstname
            avatar {
              original {
                bucket
                identityId
                key
                level
                region
              }
              squareThumbnails {
                image {
                  region
                  level
                  key
                  identityId
                  bucket
                }
                size
              }
            }
          }
          id
          createdAt
          note
        }
      }
      files {
        items {
          id
          expirationDate
          fileName
          original {
            bucket
            region
            key
            level
            identityId
          }
          fileType
          contentType
          sourceID
          ownerNationalID
          uploadDate
          uploaderEmployer {
            id
            firstname
            lastname
            slug
            avatar {
              original {
                bucket
                key
                level
                region
                identityId
              }
              squareThumbnails {
                image {
                  bucket
                  key
                  level
                  region
                  identityId
                }
                size
              }
              version
            }
          }
          uploaderForeignNational {
            id
            firstname
            lastname
            slug
            avatar {
              original {
                bucket
                key
                level
                region
                identityId
              }
              squareThumbnails {
                image {
                  bucket
                  key
                  level
                  region
                  identityId
                }
                size
              }
              version
            }
          }
          uploaderTeamMember {
            id
            firstname
            lastname
            slug
            avatar {
              original {
                bucket
                key
                level
                region
                identityId
              }
              squareThumbnails {
                image {
                  bucket
                  key
                  level
                  region
                  identityId
                }
                size
              }
              version
            }
          }
        }
      }
      individualSponsored
      jobDescriptionID
      jobDescription {
        canWorkFromHome
        certificationLicenses
        companyID
        degrees
        dotNumber
        caseSocCode
        duties
        id
        jobURL
        majors
        objectiveSkillSetsRequired
        offeredSalary
        officialTitle
        requiresBachelors
        requiresMasters
        requiresPhd
        supervisesOthers
        supervisesOthersCount
        supervisesTitles
        supervisorTitle
        title
        travelDomestic
        travelInternational
        travelIsRequired
        travelPercentage
        type
        uploadedDescriptionID
        yearsGeneralExperience
        uploadedDescription {
          id
          expirationDate
          fileName
          fileType
          contentType
          sourceID
          ownerNationalID
          uploadDate
          original {
            bucket
            identityId
            key
            level
            region
          }
        }
        specialRequirements
        createdAt
        updatedAt
      }
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      vendor {
        id
        name
        type
        location
        email
      }
      resumeID
      resume {
        fileName
        contentType
        createdAt
        original {
          bucket
          key
          level
          region
          identityId
        }
      }
      slug
      state
    }
  }
`;

export const updateProcessRequest = /* GraphQL */ `
  mutation CustomUpdateProcessRequest(
    $input: UpdateProcessRequestInput!
    $condition: ModelProcessRequestConditionInput
  ) {
    updateProcessRequest(input: $input, condition: $condition) {
      id
      companyID
      company {
        slug
        id
        name
        displayCompanyName
        primaryContacts {
          items {
            employerID
          }
        }
        data {
          addressPrimary {
            careOf
            address
            unitNumber
            unitType
            adminArea
            state
            city
            country
            postalCode
            title
            companyAddressType
          }
          addressSecondary {
            careOf
            address
            unitNumber
            unitType
            adminArea
            state
            city
            country
            postalCode
            title
            companyAddressType
          }
        }
        accountManagerID
      }
      assignedToID
      initiatorID
      employeeData {
        firstname
        lastname
        email
        tempID
        employeeId
        spouse
        dependents
      }
      employmentData {
        location {
          remoteAddress {
            address
            unitType
          }
          type
        }
        notes
        premiumProcessing
        startDate
        salary {
          currency
          amount
        }
      }
      initiator {
        id
        slug
        firstname
        lastname
      }
      requesterID
      requester {
        id
        firstname
        lastname
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
          version
        }
      }
      requestDate
      foreignNationalID
      foreignNational {
        id
        archived
        slug
        email
        employeeId
        firstname
        lastname
        spouse
        dependents
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
        immigrationStatus {
          status
          expiration
        }
      }
      caseNotes {
        items {
          authorTeamMember {
            id
            lastname
            firstname
            avatar {
              original {
                bucket
                identityId
                key
                level
                region
              }
              squareThumbnails {
                image {
                  region
                  level
                  key
                  identityId
                  bucket
                }
                size
              }
            }
          }
          id
          createdAt
          note
        }
      }
      files {
        items {
          id
          expirationDate
          fileName
          original {
            bucket
            region
            key
            level
            identityId
          }
          fileType
          contentType
          sourceID
          ownerNationalID
          uploadDate
          uploaderEmployer {
            id
            firstname
            lastname
            slug
            avatar {
              original {
                bucket
                key
                level
                region
                identityId
              }
              squareThumbnails {
                image {
                  bucket
                  key
                  level
                  region
                  identityId
                }
                size
              }
              version
            }
          }
          uploaderForeignNational {
            id
            firstname
            lastname
            slug
            avatar {
              original {
                bucket
                key
                level
                region
                identityId
              }
              squareThumbnails {
                image {
                  bucket
                  key
                  level
                  region
                  identityId
                }
                size
              }
              version
            }
          }
          uploaderTeamMember {
            id
            firstname
            lastname
            slug
            avatar {
              original {
                bucket
                key
                level
                region
                identityId
              }
              squareThumbnails {
                image {
                  bucket
                  key
                  level
                  region
                  identityId
                }
                size
              }
              version
            }
          }
        }
      }
      individualSponsored
      jobDescriptionID
      jobDescription {
        companyID
        id
        title
        degrees
        duties
        majors
        dotNumber
        caseSocCode
        jobURL
        uploadedDescriptionID
        uploadedDescription {
          id
          expirationDate
          fileName
          fileType
          contentType
          sourceID
          ownerNationalID
          uploadDate
          original {
            bucket
            identityId
            key
            level
            region
          }
        }
        specialRequirements
        createdAt
        updatedAt
      }
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      vendor {
        id
        name
        type
        location
        email
      }
      resumeID
      resume {
        fileName
        contentType
        createdAt
        original {
          bucket
          key
          level
          region
          identityId
        }
      }
      slug
      state
    }
  }
`;

export const searchProcessRequests = /* GraphQL */ `
  query CustomSearchProcessRequests(
    $and: [SearchableProcessRequestFilterInput]
    $limit: Int = 100
    $nextToken: String
  ) {
    searchProcessRequests(
      filter: { and: $and }
      nextToken: $nextToken
      limit: $limit
      sort: { field: requestDate, direction: desc }
    ) {
      items {
        id
        assignedToID
        companyID
        company {
          name
          displayCompanyName
        }
        initiatorID
        initiator {
          id
          slug
          firstname
          lastname
        }
        requesterID
        requester {
          id
          slug
          firstname
          lastname
        }
        requestDate
        employeeData {
          email
          firstname
          lastname
        }
        employmentData {
          startDate
        }
        foreignNationalID
        foreignNational {
          id
          slug
          email
          firstname
          lastname
          spouse
          dependents
          avatar {
            original {
              bucket
              key
              level
              region
              identityId
            }
            square {
              bucket
              key
              level
              region
              identityId
            }
            squareThumbnails {
              image {
                bucket
                key
                level
                region
                identityId
              }
              size
            }
            version
          }
          company {
            name
            displayCompanyName
          }
          immigrationStatus {
            status
            expiration
          }
        }
        requestedProcess
        slug
        state
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const CustomListForeignNationals = /* GraphQL */ `
  query CustomListForeignNationals(
    $filter: ModelForeignNationalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForeignNationals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        immigrationVisaStatus
        immigrationCurrentStatus
        immigrationStatus {
          status
          doesNotExpire
          expiration
        }
        immigrationStatusExpiration
        employmentBasedCategory
        priorityDate
        hasApprovedI140 {
          hasApproved
          classification
          priorityDate
          employmentBasedCategory
        }
        aosFilingEligible
        birthCountry
        birthCountryCode
        eadExpDate
        I797ExpDate
        files{
          items{
            id
            expirationDate
            fileType
          }
        }
        companyID
        companyName
        company {
          name
          displayCompanyName
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
